import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-plan',
  templateUrl: './confirm-plan.component.html',
  styleUrls: ['./confirm-plan.component.scss']
})
export class ConfirmPlanComponent implements OnInit {
	//showConfirmBox: boolean;
  @Input() modelpopup;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

	constructor(public activeModel:NgbActiveModal,protected router: Router,translate: TranslateService) {
		//this.showConfirmBox = false;
	}
  cssClass={
    14:"standard-card",
    15:"professional-card",
    16:"enterprise-card",
    46:"package-4-card",
    47:"package-5-card"
  }
  packageImage={
    14:"assets/images/new-set/standard-icon.png",
    15:"assets/images/new-set/professional-icon.png",
    16:"assets/images/new-set/enterprise-icon.png",
    46:"assets/images/new-set/package-4-icon.png",
    47:"assets/images/new-set/package-5-icon.png"
  }
	ngOnInit(): void {
	}

  close(){
    this.activeModel.close(this.modelpopup);
  }

	confirmPlan() {
    this.passEntry.emit(this.modelpopup);
    this.activeModel.close();
		//this.showConfirmBox = true;
	}
  success(){
    this.router.navigate(['/mysubscription']);
    this.activeModel.close();
  }

}
